import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRoute } from '@hvsin/mod-route';
import { usePost } from '../hooks/use-post.js';
import { ChevronLeftIcon } from '../components/icons.js';
import { MarkdownRenderer } from '../components/markdown-renderer.js';
import { MARKDOWN_CSS } from '../components/markdown-styles.js';
/**
 * 文章详情页
 */
export function PostDetailPage(props) {
    const { initialData } = props;
    const { Link, useParams } = useRoute();
    const { id: postId } = useParams();
    const { post, loading, error } = usePost(postId, initialData);
    // 格式化日期
    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleDateString('zh-CN', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };
    // 加载中
    if (loading) {
        return (_jsx("div", { style: styles.page, children: _jsx("div", { style: styles.loading, children: "\u52A0\u8F7D\u4E2D..." }) }));
    }
    // 错误或未找到
    if (error || !post) {
        return (_jsx("div", { style: styles.page, children: _jsxs("div", { style: styles.container, children: [_jsx("div", { style: styles.error, children: error || '文章不存在' }), _jsx(Link, { to: "/post", style: styles.backLink, children: "\u2190 \u8FD4\u56DE\u6587\u7AE0\u5217\u8868" })] }) }));
    }
    return (_jsxs("div", { style: styles.page, children: [_jsx("style", { children: MARKDOWN_CSS }), _jsx("header", { style: styles.header, children: _jsx("div", { style: styles.headerContent, children: _jsxs(Link, { to: "/post", style: styles.backLink, children: [_jsx(ChevronLeftIcon, {}), _jsx("span", { style: { marginLeft: '4px' }, children: "\u8FD4\u56DE" })] }) }) }), _jsx("main", { style: styles.main, children: _jsxs("article", { style: styles.article, children: [_jsxs("header", { style: styles.articleHeader, children: [_jsx("h1", { style: styles.articleTitle, children: post.title }), (post.categorySlug || post.tagSlugs?.length > 0) && (_jsxs("div", { style: styles.articleTaxonomies, children: [post.categorySlug && (_jsxs("span", { style: styles.categoryBadge, children: ["\uFFFD ", post.categorySlug] })), post.tagSlugs?.map(slug => (_jsxs("span", { style: styles.tagBadge, children: ["#", slug] }, slug)))] })), _jsxs("div", { style: styles.articleMeta, children: [_jsxs("time", { style: styles.articleDate, children: ["\u53D1\u5E03\u4E8E ", formatDate(post.createdAt)] }), post.updatedAt !== post.createdAt && (_jsxs("time", { style: styles.articleDate, children: ["\u66F4\u65B0\u4E8E ", formatDate(post.updatedAt)] }))] })] }), _jsx("hr", { style: styles.divider }), _jsx(MarkdownRenderer, { contentHtml: post.contentHtml })] }) })] }));
}
const styles = {
    page: {
        minHeight: '100vh',
        backgroundColor: '#fafafa',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        color: '#1a1a1a',
    },
    header: {
        backgroundColor: '#ffffff',
        borderBottom: '1px solid #eaeaea',
        padding: '16px 24px',
    },
    headerContent: {
        maxWidth: '960px',
        margin: '0 auto',
    },
    backLink: {
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: '14px',
        color: '#666',
        textDecoration: 'none',
        fontWeight: 500,
    },
    main: {
        maxWidth: '960px',
        margin: '0 auto',
        padding: '40px 24px 60px',
    },
    container: {
        maxWidth: '960px',
        margin: '0 auto',
        padding: '80px 24px',
    },
    loading: {
        padding: '120px 0',
        textAlign: 'center',
        color: '#999',
        fontSize: '15px',
    },
    error: {
        padding: '24px',
        backgroundColor: '#fff5f5',
        border: '1px solid #fed7d7',
        borderRadius: '8px',
        color: '#c53030',
        fontSize: '15px',
        textAlign: 'center',
        marginBottom: '24px',
    },
    article: {
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        padding: '48px',
        border: '1px solid #eaeaea',
    },
    articleHeader: {
        marginBottom: '32px',
    },
    articleTitle: {
        margin: '0 0 16px 0',
        fontSize: '30px',
        fontWeight: 700,
        lineHeight: '1.3',
        color: '#1a1a1a',
        letterSpacing: '-0.02em',
    },
    articleTaxonomies: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        marginBottom: '16px',
    },
    categoryBadge: {
        display: 'inline-block',
        padding: '4px 10px',
        backgroundColor: '#f0fdf4',
        color: '#166534',
        borderRadius: '6px',
        fontSize: '13px',
        fontWeight: 500,
        border: '1px solid #bbf7d0',
    },
    tagBadge: {
        display: 'inline-block',
        padding: '4px 8px',
        borderRadius: '6px',
        fontSize: '13px',
        color: '#6366f1',
        backgroundColor: '#eef2ff',
        border: '1px solid #c7d2fe',
    },
    articleMeta: {
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        flexWrap: 'wrap',
    },
    articleDate: {
        fontSize: '14px',
        color: '#999',
    },
    divider: {
        border: 'none',
        borderTop: '1px solid #eaeaea',
        margin: '0 0 32px 0',
    },
};
//# sourceMappingURL=post-detail-page.js.map